import { type FC } from 'react'
import { Button } from '@egw/components'
import { useTranslation } from '@egw/i18n'
import { EnrollmentHYCSLayout } from '@egw/layouts'
import { useNavigate } from 'react-router'
import { WEALTH_ROUTES } from '@egw/constants'
import { PageHeader } from '../../../components'

export const TimedOutPage: FC = () => {
  const { t } = useTranslation('features-enrollment')
  const navigate = useNavigate()

  const onSubmit = (): void => {
    navigate(WEALTH_ROUTES.ENROLLMENT.path)
  }

  return (
    <EnrollmentHYCSLayout>
      <div className="egw-container-enroll-hycs h-full flex flex-col relative md:justify-center justify-start items-start">
        <PageHeader title={t('generic.timed_out.title')} />
        <p className="typo-primary-base-regular text-text-body mb-md">{t('generic.timed_out.paragraph_1')}</p>
        <p className="typo-primary-base-regular text-text-body">{t('generic.timed_out.paragraph_2')}</p>
        <div className="flex-1 md:hidden" />
        <Button type="button" className="w-full md:w-min mt-lg" testId="enrollment-continue-button" onClick={onSubmit}>
          {t('generic.timed_out.action')}
        </Button>
      </div>
    </EnrollmentHYCSLayout>
  )
}
